export enum UrlParamKey {
	autoSubmit = 'autoSubmit',
	format = 'format'
}

export enum UrlParamPrefix {
	CFModel = "T.",
	Clipboard = "CP."
}